var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector29 = function SvgVector29(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001D52",
    d: "M.75 9.5c0 4.744 3.874 8.75 8.75 8.75 4.881 0 8.75-4.013 8.75-8.75 0-4.819-3.926-8.75-8.75-8.75C4.649.75.75 4.71.75 9.5m16.208.74-3.692.336a3.12 3.12 0 0 0-2.805 2.637l-.58 3.768c-.527.027-.234.027-.761 0l-.58-3.768a3.12 3.12 0 0 0-2.805-2.637l-3.693-.336c-.064-.595-.043-.793-.018-1.197 4.963-1.87 9.99-1.87 14.954 0 .023.405.044.602-.02 1.197M2.283 11.517l3.338.303a1.87 1.87 0 0 1 1.683 1.582l.523 3.403a7.52 7.52 0 0 1-5.544-5.288m8.889 5.289.524-3.404a1.87 1.87 0 0 1 1.683-1.581l3.337-.303a7.52 7.52 0 0 1-5.544 5.288M9.5 2c3.49 0 6.423 2.4 7.256 5.634-4.821-1.66-9.691-1.66-14.512 0C3.077 4.4 6.01 2 9.5 2"
  })));
};
export default SvgVector29;